import { Grid, SxProps } from "@mui/material";
import React, { useRef } from "react";
import theme from "Theme/AppTheme";
import { observer } from "mobx-react";
import useHoverAction from "../../hooks/useHoverAction";
import DeleteButton from "../../components/DeleteButton";
import Tag from "./Tag";

type StatementProps = {
    remove?: () => void;
    label?: string;
    separatorLabel?: string;
    children?: React.ReactNode;
    sx?: SxProps;
};

const Statement: React.FC<StatementProps> = observer(
    ({ remove, label, separatorLabel, children, sx }) => {
        const containerRef = useRef<HTMLDivElement>(null);
        const { showAction, handlers } = useHoverAction(containerRef);

        return (
            <Grid
                container
                sx={{
                    display: "flex",
                    alignItems: "center",
                    ...sx,
                }}
            >
                {label && <Tag text={label} />}
                <Grid
                    item
                    ref={containerRef}
                    {...handlers}
                    xs={11}
                    xl={10}
                    sx={{
                        display: "flex",
                        gap: theme.spacing(2),
                        padding: theme.spacing(1, 0),
                        borderRadius: 2,
                    }}
                >
                    {children}
                    {remove && (
                        <DeleteButton
                            showDelete={showAction}
                            onDelete={remove}
                            sx={{ margin: theme.spacing(1, -1) }}
                        />
                    )}
                </Grid>
                {separatorLabel && (
                    <Grid xs={12} item>
                        <Tag text={separatorLabel} />
                    </Grid>
                )}
            </Grid>
        );
    },
);

export default Statement;
